import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PageAccesses } from '../../../core/guards/page-accesses.model';
import { PageAccessesService } from '../../../core/services/page-access/page-access.service';
import { PageListViewModel, PageStatus } from '../../../page-screen/components/page-screen/page-screen.view-model';
import { AdminUiPageActions } from '../../../domain/admin-ui-details';

@Component({
  selector: 'osn-cxb-page-list',
  templateUrl: './page-list.component.html',
  styleUrls: ['./page-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageListComponent {
  @Input() public pages: PageListViewModel[];
  @Input() public isLoading = false;
  @Input() public showType = false;
  @Input() public showTargeting = false;
  @Input() public showAttachedGenre = false;
  @Input() public tenantSpecificActions?: AdminUiPageActions;
  @Input('data-testid') testId = 'page-list-component';
  public readonly PageStatus = PageStatus;
  public accesses: PageAccesses;

  constructor(private readonly pageAccessService: PageAccessesService) {
    this.accesses = this.pageAccessService.usersPageAccesses$.value;
  }

  public getProperty(property: keyof PageListViewModel): keyof PageListViewModel {
    return property;
  }

  public castRow(row: any): PageListViewModel {
    return row;
  }

  public getTooltipText(list?: string[]): string {
    if (!list || list.length <= 1) {
      return '';
    }
    let resultText = '';
    list.forEach((userSegment) => {
      resultText = resultText.concat(`${this.titleCase(userSegment)}\n`);
    });
    return resultText;
  }

  private titleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
}
